<dashboardnav>
  
    <cradua-network
    [networks]="networks$ | async"
    (network)="onSubmitNetwork($event)"
    (deleteNetworkEvent)="onDeleteNetwork($event)"
    *ngIf="(isLoading$ | async ) === false"
    >
  </cradua-network>
  
    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoading$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
  